import { render, staticRenderFns } from "./Requestinboxdetailed.vue?vue&type=template&id=ea7a16fa"
import script from "./Requestinboxdetailed.vue?vue&type=script&lang=js"
export * from "./Requestinboxdetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports